module.exports = __webpack_public_path__ + "static/img/operaingCostb.12fd5ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/operaingCostb.png
// module id = 4dgQ
// module chunks = 1